<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.HWC.RDS.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:hwc:relationalDatabaseServiceResourceHwc:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:hwc:relationalDatabaseServiceResourceHwc:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <relational-database-service-resource-hwc-search
      ref="child"
    ></relational-database-service-resource-hwc-search>
    <table-relational-database-service-resource-hwc></table-relational-database-service-resource-hwc>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import RelationalDatabaseServiceResourceHwcSearch from "./RelationalDatabaseServiceResourceHwcSearch.vue";
import TableRelationalDatabaseServiceResourceHwc from "./TableRelationalDatabaseServiceResourceHwc.vue";
import Export from "../../hwc/Export.vue";
var tableRelationalDatabaseServiceResourceHwc =
  TableRelationalDatabaseServiceResourceHwc;
export default {
  name: "RelationalDatabaseServiceResourceGcp",
  components: {
    RelationalDatabaseServiceResourceHwcSearch,
    TableRelationalDatabaseServiceResourceHwc,
    Export
  },
  data() {
    return {
      modal_loading: false,
      loading: false
    };
  },
  methods: {
    update() {
      this.loading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          resourceManagement: 1,
          accountType: 5
        })
        .then(res => {
          this.loading = false;
          tableRelationalDatabaseServiceResourceHwc.methods.showAll();
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList() {
      let exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIds: this.$refs.child.accountNameSearchKey,
        accountName: this.$refs.child.accountName,
        databaseId: this.$refs.child.instanceId
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportHWCDatabase(exportDTO).then(res => {
        let fileName = "云数据库.xls";
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success("导出成功");
      });
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/rds/RelationalDatabaseServiceResourceHwc.vue